import React from 'react';
import { useNavigationState } from '../../hooks/useNavigationState';
import NavigationItem from './NavigationItem';
import { FileOutput, Image, Cog, Menu } from 'lucide-react';

/**
 * サイドナビゲーションコンポーネント
 * アプリケーションの主要な機能間のナビゲーションを提供する
 */
const Navigation: React.FC = () => {
  //#region ステート管理
  const { isExpanded, toggleNavigation } = useNavigationState();
  //#endregion

  //#region ナビゲーションアイテムの定義
  /**
   * ナビゲーション項目の配列
   * 新しい機能を追加する際は、この配列に項目を追加する
   */
  const navigationItems = [
    {
      icon: <FileOutput size={24} />,
      label: 'NC変換',
      path: '/nc-conversion',
      description: 'NCファイルを他の形式に変換',
    },
    {
      icon: <Image size={24} />,
      label: '図面変換',
      path: '/drawing-conversion',
      description: '図面ファイルを他の形式に変換',
    },
    {
      icon: <Cog size={24} />,
      label: '設定',
      path: '/settings',
      description: 'アプリケーション設定',
    },
  ];
  //#endregion

  //#region レンダリング
  return (
    <nav
      className={`
        fixed left-0 top-0 h-full bg-gray-900 text-white
        transition-all duration-300 ease-in-out
        ${isExpanded ? 'w-64' : 'w-16'}
        z-50
      `}
    >
      {/* ハンバーガーメニュー */}
      <div className="flex items-center justify-between p-4">
        <button
          onClick={toggleNavigation}
          className="p-2 rounded-lg hover:bg-gray-800 transition-colors"
          aria-label="Toggle navigation"
        >
          <Menu size={24} />
        </button>
      </div>

      {/* ナビゲーションリスト */}
      <div className="mt-4">
        {navigationItems.map((item) => (
          <NavigationItem
            key={item.path}
            icon={item.icon}
            label={item.label}
            path={item.path}
            description={item.description}
            isExpanded={isExpanded}
          />
        ))}
      </div>
    </nav>
  );
};

export default Navigation;